import makeStyles from '@material-ui/core/styles/makeStyles';

import { colors } from '../../../assets';

export const useStyles = makeStyles(theme => ({
  dropZone: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    padding: 16,
    border: `2px dashed ${colors.grey60}`,
    borderRadius: 4,
    transition: theme.transitions.create(['border-color', 'background-color']),
  },
  dropZoneActive: {
    borderColor: colors.primary.main,
    backgroundColor: colors.primary.superlight,
  },
  dropZoneDisabled: {
    opacity: 0.6,
  },
  hint: {
    color: colors.grey140,
    pointerEvents: 'none',
  },
}));
